enum PaymentCurrency {
    USD = 'usd',
}

export default PaymentCurrency;
